import type { CellColor, Grid } from "../types.ts";
import { getTopColor } from "./grid.ts";

export function getVisibleSurface(grid: Grid): CellColor[][] {
  const surface: CellColor[][] = [];
  for (let r = 0; r < grid.rows; r++) {
    surface[r] = [];
    for (let c = 0; c < grid.cols; c++) {
      surface[r]![c] = getTopColor(grid.cells[r]![c]!);
    }
  }
  return surface;
}

export function matchesTarget(grid: Grid, target: CellColor[][]): boolean {
  if (grid.rows !== target.length) return false;
  if (grid.cols !== (target[0]?.length ?? 0)) return false;

  const surface = getVisibleSurface(grid);
  for (let r = 0; r < grid.rows; r++) {
    for (let c = 0; c < grid.cols; c++) {
      if (surface[r]![c] !== target[r]![c]) return false;
    }
  }
  return true;
}
